import { useState, type FormEvent } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';

const NAV_ITEMS = [
  { label: '首页', to: '/' },
  { label: '电影', to: '/category/movie' },
  { label: '电视剧', to: '/category/tv' },
  { label: '综艺', to: '/category/variety' },
  { label: '关于我们', to: '/about' },
];

export default function SiteHeader() {
  const navigate = useNavigate();
  const location = useLocation();
  const [keyword, setKeyword] = useState('');
  const [menuOpen, setMenuOpen] = useState(false);

  const handleSearch = (e: FormEvent) => {
    e.preventDefault();
    const q = keyword.trim();
    if (!q) return;
    navigate(`/search?q=${encodeURIComponent(q)}`);
    setMenuOpen(false);
  };

  const isActive = (to: string) =>
    to === '/' ? location.pathname === '/' : location.pathname.startsWith(to.split('?')[0]);

  return (
    <header className="sticky top-0 z-50 w-full border-b border-background-200/70 bg-background-50/90 backdrop-blur">
      <div className="w-full px-4 md:px-8">
        <div className="flex h-16 items-center gap-4">
          <Link to="/" className="flex items-center gap-2 shrink-0" onClick={() => setMenuOpen(false)}>
            <span className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center">
              <i className="ri-film-line text-xl text-background-50"></i>
            </span>
            <span className="font-heading text-xl font-extrabold tracking-tight text-foreground-950">
              妖精<span className="text-primary-500">视频</span>
            </span>
          </Link>

          <nav className="hidden md:flex items-center gap-1 ml-4">
            {NAV_ITEMS.map((item) => (
              <Link
                key={item.to}
                to={item.to}
                className={`px-3.5 py-2 text-sm font-medium rounded-md transition-colors ${
                  isActive(item.to)
                    ? 'text-primary-600 bg-primary-50'
                    : 'text-foreground-700 hover:text-primary-600 hover:bg-background-100'
                }`}
              >
                {item.label}
              </Link>
            ))}
          </nav>

          <form onSubmit={handleSearch} className="hidden md:flex items-center ml-auto">
            <div className="relative">
              <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-foreground-400 text-sm"></i>
              <input
                type="text"
                value={keyword}
                onChange={(e) => setKeyword(e.target.value)}
                placeholder="搜索影片、剧集、综艺"
                className="w-56 lg:w-72 rounded-md border border-background-300 bg-background-100 py-2 pl-9 pr-3 text-sm text-foreground-900 placeholder:text-foreground-400 outline-none transition-all focus:border-primary-400 focus:bg-background-50 focus:ring-2 focus:ring-primary-100"
              />
            </div>
            <button
              type="submit"
              className="ml-2 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
            >
              搜索
            </button>
          </form>

          <button
            type="button"
            aria-label="打开菜单"
            onClick={() => setMenuOpen((v) => !v)}
            className="md:hidden ml-auto w-10 h-10 flex items-center justify-center rounded-md border border-background-300 text-foreground-800"
          >
            <i className={menuOpen ? 'ri-close-line text-xl' : 'ri-menu-line text-xl'}></i>
          </button>
        </div>
      </div>

      {menuOpen && (
        <div className="md:hidden border-t border-background-200 bg-background-50 px-4 py-4">
          <form onSubmit={handleSearch} className="flex items-center gap-2 mb-3">
            <div className="relative flex-1">
              <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-foreground-400 text-sm"></i>
              <input
                type="text"
                value={keyword}
                onChange={(e) => setKeyword(e.target.value)}
                placeholder="搜索影片、剧集、综艺"
                className="w-full rounded-md border border-background-300 bg-background-100 py-2 pl-9 pr-3 text-sm outline-none focus:border-primary-400"
              />
            </div>
            <button
              type="submit"
              className="whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-semibold text-background-50"
            >
              搜索
            </button>
          </form>
          <div className="flex flex-col">
            {NAV_ITEMS.map((item) => (
              <Link
                key={item.to}
                to={item.to}
                onClick={() => setMenuOpen(false)}
                className={`px-3 py-3 text-sm font-medium rounded-md ${
                  isActive(item.to) ? 'text-primary-600 bg-primary-50' : 'text-foreground-700'
                }`}
              >
                {item.label}
              </Link>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}